import React, { useContext, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Button from '../Button';
import Typography from '../Typography';
import LogoutIcon from '../SvgIcons/LogoutIcon';
import { useDispatch } from 'react-redux';
import { setAddCustomerModal } from '../../redux/reducers/admin/customer';
import { useLogout, useValidateLogin } from '../../hooks/auth';
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom';
import {
  setAddFindingsModal,
  setAddUsersModal,
  setInviteCustomerModal,
  setNewPentestModal,
  setUpdatePentestLandscape,
  setImportAssetsModal,
  setNewEASMModal,
  setSubscribeModal,
  setSetupVAModal,
  setGenptSubscribeModal,
  setEASMSubscribeModal,
  setEasmSubscribeModal,
  setInviteTeamModal,
} from '../../redux/reducers/dashboard';
import EditIcon from '../SvgIcons/EditIcon';
import { useCreateFindings } from '../../hooks/findings';
import MainLoader from '../Loader/MainLoader';
import SlackIcon from '../SvgIcons/SlackIcon';
import { SLACK_CLIENT_ID } from '../../utils/constants';
import { usePentestById } from '../../hooks/pentest';
import { useAssetById } from '../../hooks/asset';
import Storage from '../../utils/Storage';
import EASMIconGrey from '../SvgIcons/EASMIconGrey';
import VAIconGrey from '../SvgIcons/VALogoGrey';
import SiembaGPTIconGrey from '../SvgIcons/GPTIconGrey';
import SiembaGPTIconTheme from '../SvgIcons/GPTIconTheme';
import ShieldIcon from '@mui/icons-material/Shield';
import PlayArrowOutlined from '@mui/icons-material/PlayArrowOutlined';
import EASMIconTheme from '../SvgIcons/EASMIconTheme';
import VAIconTheme from '../SvgIcons/VALogoTheme';
import { SIEMBA_ADMIN } from '../../utils/roles';
import { useAppMode } from '../../Providers/AppModeProvider';

/** Fixed rail for START / header dropdown rows so labels align regardless of SVG intrinsic size */
const MENU_ROW_ICON_SLOT =
  'flex h-8 w-10 shrink-0 items-center justify-center';

export const AddCustomer = (props) => {
  const { className } = props;
  const dispatch = useDispatch();
  const [colorChange, setColorChange] = useState(false);
  return (
    <Button
      onClick={() => dispatch(setAddCustomerModal(true))}
      onMouseEnter={() => setColorChange(true)}
      onMouseLeave={() => setColorChange(false)}
      size={'small'}
      variant={'contained'}
      className={`z-100 cursor-pointer bg-transparent ${colorChange ? 'primary-color' : 'text-grey'
        } !p-0 ${className}`}
    >
      <span className="ml-2">
        <AddIcon />
      </span>{' '}
      <span className="ml-1">Add Customer</span>
    </Button>
  );
};
export const ImportAssets = (props) => {
  const dispatch = useDispatch();
  const { className, companyId } = props;
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin');
  return (
    <>
      {isAdmin && (
        <Button
          onClick={() => {
            dispatch(
              setImportAssetsModal({
                open: true,
                companyId: companyId,
              })
            );
          }}
          fullWidth={true}
          size={'small'}
          variant={'outlined'}
          className={`${className} text-[12px] md:text-[16px]`}
        >
          Import Assets
        </Button>
      )}
    </>
  );
};

export const AddFindings = (props) => {
  const { className } = props;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin');
  const [colorChange, setColorChange] = useState(false);
  return (
    <Button
      onClick={() => dispatch(setAddFindingsModal({ open: true }))}
      onMouseEnter={() => setColorChange(true)}
      onMouseLeave={() => setColorChange(false)}
      size={'small'}
      variant={'contained'}
      className={`bg-transparent ${colorChange ? 'primary-color' : 'text-grey'} !p-0 ${className}`}
    >
      <span className="ml-2">
        <AddIcon />
      </span>{' '}
      <span className="ml-1">Add Finding</span>
    </Button>
  );
};

export const AddPartner = (props) => {
  const { className } = props;
  return (
    <Button
      fullWidth={true}
      size={'small'}
      variant={'contained'}
      className={`!bg-secondary-700 ${className}`}
    >
      <AddIcon /> Add Partner
    </Button>
  );
};

export const StartNewPentest = (props) => {
  const dispatch = useDispatch();
  const [colorChange, setColorChange] = useState(false);
  const { className, label, disabled = false, showIcon = true, usePlayIcon = false } = props;
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin');
  let isDashboard = pathname?.startsWith('/app') || isAdmin;

  const startPentest = () => {
    if (disabled) return; // prevent clicks if disabled
    props?.onStart?.();

    dispatch(
      setNewPentestModal({
        open: true,
        progress: isAdmin ? 'pentest_company' : 'pentest_profile',
        companyId: props?.companyId,
        companyName: props?.companyName,
      })
    );
  };

  return (
    <>
      {isDashboard && (
        <div
          className={`flex w-full items-center gap-2 ${disabled ? 'opacity-50 !cursor-default' : ''}`}
          style={{ cursor: disabled ? 'default' : 'pointer' }}
          onClick={startPentest}
          onMouseEnter={() => !disabled && setColorChange(true)}
          onMouseLeave={() => !disabled && setColorChange(false)}
          aria-disabled={disabled}
        >
          {showIcon && (
            <div className={MENU_ROW_ICON_SLOT}>
              {usePlayIcon ? (
                <PlayArrowOutlined
                  sx={{
                    fontSize: 22,
                    color: disabled ? '#9ca3af' : colorChange ? '#12AFB8' : '#6b7280',
                  }}
                />
              ) : (
                <ShieldIcon
                  htmlColor={disabled ? '#666' : colorChange ? '#12AFB8' : '#666'}
                  className="sheild-icon"
                />
              )}
            </div>
          )}
          <Button
            size="small"
            aria-disabled={disabled}
            disableRipple
            disableFocusRipple
            className={`bg-transparent ${disabled ? 'text-grey !cursor-default' : colorChange ? 'primary-color' : 'text-grey'
              } !m-0 !min-h-0 !p-0 !normal-case ${className ?? ''}`}
          >
            {label ?? 'PENTEST'}
          </Button>
        </div>
      )}
    </>
  );
};

export const StartNewEASM = (props) => {
  const dispatch = useDispatch();
  const [colorChange, setColorChange] = useState(false);
  const { className, label, redirection = false, disabled = false, showIcon = true } = props;
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin');
  let isDashboard = pathname?.startsWith('/app') || isAdmin;

  const startEasm = () => {
    if (disabled) return; // prevent clicks if disabled
    const easm_enabled = Storage.decryptStorageData('easm_enabled') === 'true';
    if (easm_enabled) {
      dispatch(setNewEASMModal({
        open: true,
        redirection,
        companyId: props?.companyId,
        companyName: props?.companyName,
      }));
    } else {
      dispatch(setEasmSubscribeModal({ open: true }));
    }
  };

  return (
    <>
      {isDashboard && props?.isEASM ? (
        <Button
          onClick={startEasm}
          fullWidth
          size="small"
          variant="contained"
          aria-disabled={disabled}
          disableRipple
          disableFocusRipple
          className={`!bg-primary-500 ${disabled ? 'opacity-50 !cursor-default' : ''} ${className}`}
        >
          {label ?? 'EASM'}
        </Button>
      ) : (
        <div
          className={`flex w-full items-center gap-2 ${disabled ? 'opacity-50 !cursor-default' : ''}`}
          style={{ cursor: disabled ? 'default' : 'pointer' }}
          onClick={startEasm}
          onMouseEnter={() => !disabled && setColorChange(true)}
          onMouseLeave={() => !disabled && setColorChange(false)}
          aria-disabled={disabled}
        >
          {showIcon && (
            <div className={MENU_ROW_ICON_SLOT}>
              {disabled ? <EASMIconGrey /> : colorChange ? <EASMIconTheme /> : <EASMIconGrey />}
            </div>
          )}
          <Button
            size="small"
            aria-disabled={disabled}
            disableRipple
            disableFocusRipple
            className={`bg-transparent ${disabled ? 'text-grey !cursor-default' : colorChange ? 'primary-color' : 'text-grey'
              } !m-0 !min-h-0 !p-0 ${className}`}
          >
            {label ?? 'EASM'}
          </Button>
        </div>

      )}
    </>
  );
};


export const StartNewGenPT = (props) => {
  const [colorChange, setColorChange] = useState(false);
  const { data } = useValidateLogin();
  let genpt_enabled = Storage.decryptStorageData('genpt_enabled') === 'true';
  const {
    className,
    label,
    from,
    showIcon = true,
    query = '',
    isDisabled = false,
    usePlayIcon = false,
  } = props;
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin');
  let isDashboard = pathname?.startsWith('/app') || isAdmin;
  const navigate = useNavigate();
  const mainUrl = data?.user?.user_type == 'provider' ? '/admin' : '/app';
  const dispatch = useDispatch();
  const startGenpt = () => {
    if (genpt_enabled) {
      navigate(`${mainUrl}/genpt/tests/start${query}`);
      window.location.reload();
    } else {
      dispatch(
        setGenptSubscribeModal({
          open: true,
          from: from,
        })
      );
    }
  };

  return (
  <>
    {isDashboard && (
      <div
        className={`flex w-full items-center gap-2 ${
          isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}
        onClick={!isDisabled ? startGenpt : undefined}
        onMouseEnter={!isDisabled ? () => setColorChange(true) : undefined}
        onMouseLeave={!isDisabled ? () => setColorChange(false) : undefined}
      >
        {showIcon && (
          <div className={MENU_ROW_ICON_SLOT}>
            {usePlayIcon ? (
              <PlayArrowOutlined
                sx={{
                  fontSize: 22,
                  color: isDisabled ? '#9ca3af' : colorChange ? '#12AFB8' : '#6b7280',
                }}
              />
            ) : isDisabled ? (
              <SiembaGPTIconGrey />
            ) : colorChange ? (
              <SiembaGPTIconTheme />
            ) : (
              <SiembaGPTIconGrey />
            )}
          </div>
        )}

        <Button
          size="small"
          className={`
            bg-transparent !m-0 !min-h-0 !p-0 !normal-case
            ${isDisabled ? 'text-grey cursor-not-allowed' : colorChange ? 'primary-color' : 'text-grey'}
            ${className ?? ''}
          `}
        >
          {label ?? 'GENPT'}
        </Button>
      </div>
    )}
  </>
);

};

export const StartNewVA = (props) => {
  const [colorChange, setColorChange] = useState(false);
  const { data } = useValidateLogin();
  const dispatch = useDispatch();
  const mainUrl = data?.user?.user_type === 'provider' ? '/admin' : '/app';
  const navigate = useNavigate();

  const { className, label, disabled = false, showIcon = true } = props;
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin');
  let isDashboard = pathname?.startsWith('/app') || isAdmin;

  const openSubscribeModal = () => {
    if (disabled) return; // prevent clicks if disabled
    navigate(`${mainUrl}/va_overview`);
    window.location.reload();
  };

  return (
    <>
      {isDashboard && (
        <div
          className={`flex w-full items-center gap-2 ${disabled ? 'opacity-50 !cursor-default' : ''}`}
          style={{ cursor: disabled ? 'default' : 'pointer' }}
          onClick={openSubscribeModal}
          onMouseEnter={() => !disabled && setColorChange(true)}
          onMouseLeave={() => !disabled && setColorChange(false)}
          aria-disabled={disabled}
        >
          {showIcon && (
            <div className={MENU_ROW_ICON_SLOT}>
              {disabled ? <VAIconGrey /> : colorChange ? <VAIconTheme /> : <VAIconGrey />}
            </div>
          )}
          <Button
            size="small"
            variant="text"
            color="inherit"
            disableRipple
            disableFocusRipple
            aria-disabled={disabled}
            sx={{
              backgroundColor: 'transparent',
              minHeight: 0,
              padding: 0,
              '&:hover': { backgroundColor: 'transparent' },
              '&:focus': { backgroundColor: 'transparent' },
              '&:active': { backgroundColor: 'transparent' },
            }}
            className={`
              !m-0 !min-h-0 !bg-transparent !p-0 !shadow-none hover:!bg-transparent
              ${disabled ? 'text-grey !cursor-default' : colorChange ? 'primary-color' : 'text-grey'}
              !normal-case ${className}
            `}
          >
            {label ?? 'VUL. ASSESSMENT'}
          </Button>
        </div>
      )}
    </>
  );
};

export const AddUsers = (props) => {
  const dispatch = useDispatch();
  const { className } = props;
  const { pathname } = useLocation();
  const isAdmin = pathname?.startsWith('/admin/user_management');
  return (
    <>
      {isAdmin && (
        <Button
          onClick={() => {
            dispatch(
              setAddUsersModal({
                open: true,
              })
            );
          }}
          fullWidth={true}
          size={'small'}
          variant={'contained'}
          className={`${isAdmin && '!bg-secondary-700 flex flex-nowrap'} ${className}`}
        >
          <AddIcon />
          <div className='whitespace-nowrap'>Add Users</div>
        </Button>
      )}
    </>
  );
};

export const InviteCustomer = (props) => {
  const dispatch = useDispatch();
  const { className } = props;
  const { pathname } = useLocation();
  const isDashboard = pathname?.startsWith('/app');
  const { APP_MODE, invited, totalInvites, dateExpired } = useAppMode();

  const isDisabled = APP_MODE === 'genptbeta' && (invited >= totalInvites || dateExpired);

  return (
    <>
      {isDashboard && (
        <Button
          onClick={() => {
            if (APP_MODE === 'genptbeta') {
              dispatch(setInviteTeamModal({ open: true }));
            } else {
              dispatch(setInviteCustomerModal({ open: true }));
            }
          }}
          fullWidth={true}
          size={'small'}
          variant={'contained'}
          className={`!bg-secondary-700 ${className}`}
          disabled={isDisabled}
        >
          <AddIcon /> Add New User
        </Button>
      )}
    </>
  );
};

export const SeeScope = (props) => {
  const location = useMatch('/app/all_assets/:id/dashboard');
  const asset_id = location?.params?.id;
  const { className } = props;
  return (
    <>
      {asset_id && (
        <Link to={`/app/all_assets/${asset_id}/edit_scope`}>
          <Button
            fullWidth={true}
            size={'small'}
            variant={'contained'}
            className={`!bg-secondary-700 ${className}`}
          >
            <EditIcon
              pathProps={{
                className: 'fill-white',
                style: {
                  fillOpacity: 1,
                },
              }}
            />{' '}
            See/Edit Scope
          </Button>
        </Link>
      )}
    </>
  );
};

export const AddFindingsToThisAsset = (props) => {
  const testerPath = useMatch('/tester/all_assets/:id/dashboard');
  const adminPath = useMatch('/admin/all_assets/:id/dashboard');
  const location = testerPath || adminPath;
  const asset_id = location?.params?.id;
  let { isFetching, data: assetData } = useAssetById(asset_id);
  let asset = assetData?.pentestAsset?.asset;
  let platform_category = asset?.platform_category;
  const { className } = props;
  const mutation = useCreateFindings();
  const dispatch = useDispatch();
  const openAddFindingsModal = async (platform_category) => {
    let payload = {
      pentest_asset_id: asset_id,
      finding_data: {
        is_draft: true,
      },
    };
    let res = await mutation.mutateAsync(payload);
    dispatch(
      setAddFindingsModal({
        open: true,
        asset_id: asset_id,
        finding_id: res.id,
        platform_category: platform_category,
      })
    );
  };
  return (
    <>
      {mutation?.isLoading && <MainLoader />}
      {
        asset_id && <></>
        // <Button onClick={() => openAddFindingsModal(platform_category)} fullWidth={true} size={"small"} variant={"contained"}
        //     className={`!bg-primary-400 ${className}`} addIcon={true}> Add Findings To This Asset</Button>
      }
    </>
  );
};
export const UpdatePentestLandScapeButton = (props) => {
  const customerPath = useMatch('/app/all_pentests/:id/dashboard');
  const adminPath = useMatch('/admin/all_pentests/:id/dashboard');
  const location = customerPath || adminPath;
  const pentest_id = location?.params?.id;
  const { data: userData } = useValidateLogin();
  const isSiembaAdmin = userData?.user?.role == SIEMBA_ADMIN;
  let { isFetching, data } = usePentestById(pentest_id);
  const { className } = props;
  const dispatch = useDispatch();
  const openUpdatePentestLandscapeModal = () => {
    dispatch(setUpdatePentestLandscape(true));
  };
  return (
    <>
      {customerPath && pentest_id && data && data.pentest.stage !== 'closed' && (
        <Button
          onClick={openUpdatePentestLandscapeModal}
          fullWidth={false}
          size={'small'}
          variant={'contained'}
          className={`!bg-secondary-700 ${className}`}
        >
          <EditIcon
            pathProps={{
              className: 'fill-white',
              style: {
                fillOpacity: 1,
              },
            }}
          />{' '}
          Update Pentest Landscape
        </Button>
      )}
      {adminPath && pentest_id && (isSiembaAdmin || data?.status !== 'completed') && (
        <Link to={`/admin/all_pentests/${pentest_id}/update`} className={{ className }}>
          <Button
            fullWidth={true}
            size={'small'}
            variant={'contained'}
            className={`!bg-secondary-700 ${className}`}
          >
            <EditIcon
              pathProps={{
                className: 'fill-white',
                style: {
                  fillOpacity: 1,
                },
              }}
            />{' '}
            Update Pentest Landscape
          </Button>
        </Link>
      )}
    </>
  );
};
export const MyTeam = (props) => {
  const { className } = props;
  return (
    <Link to={'/admin/team'}>
      <Button size={'small'} fullWidth={true} variant={'outlined'} className={className}>
        My Team
      </Button>
    </Link>
  );
};

export const SlackButton = (props) => {
  const origin = window.location.origin;
  const { className } = props;
  const { pathname } = useLocation();
  const isDashboard = pathname?.startsWith('/app');

  const slackSharableUrl = `https://slack.com/oauth/v2/authorize?client_id=${SLACK_CLIENT_ID}&scope=chat:write,users:read,users:read.email,groups:write&redirect_uri=${origin}/connect_siemba&user_scope=`;

  return (
    <>
      {isDashboard && (
        <a href={slackSharableUrl}>
          <Button
            size="small"
            fullWidth
            variant="contained"
            className={`${className} !bg-[#4A154B]`}
          >
            <SlackIcon />
            Link With Slack
          </Button>
        </a>
      )}
    </>
  );
};

export const Account = (props) => {
  const { data } = useValidateLogin();
  return (
    <>
      <Typography variant={'caption'} className={'text-[10px]'}>
        Signed In As
      </Typography>
      <Typography variant={'caption'} className={'text-secondary-700 mt-1'}>
        {data?.user?.email}
      </Typography>
    </>
  );
};
export const Logout = (props) => {
  const logout = useLogout();
  return (
    <div className={'cursor-pointer'}>
      <Typography onClick={() => logout.mutate()} variant={'caption'} className={'font-semibold'}>
        <LogoutIcon className={'text-body'} />
        &nbsp;Sign Out
      </Typography>
    </div>
  );
};
